import React from "react";
import OAuthCallbackShell from "./OAuthCallbackShell";

const buildPayload = (params) => ({
  code:  params.get("code")  || "",
  state: params.get("state") || "",
});

const SnapchatAdsCallback = () => (
  <OAuthCallbackShell
    platform="Snapchat Ads"
    endpoint="/api/ads-auth/snapchat/callback"
    buildPayload={buildPayload}
  />
);

export default SnapchatAdsCallback;
